<template>
  <div class="salesOnDay container container_content animated animatedFadeInUp fadeInUp">
    <div class="salesOnDay__title" :class="{'salesOnDay__title_margin-bottom': isStoreCount}">Выкупы по дням</div>

    <template v-if="isStoreCount">
      <div class="table">
        <template v-for="(bucket, index) in days">
          <div class="table__item table__item_height table__item_margin-bottom table__item_padding" :key="bucket.key + index + 2" v-if="bucket.doc_count > 0"
               :class="{'salesOnDay__tr_green': formatPrice(bucket.sum.value) === formatPrice(setMaxNumber), 'salesOnDay__tr_red' : formatPrice(bucket.sum.value) === formatPrice(setMinNumber)}">
            <div class="table__item-name">{{dateFormat(bucket.key_as_string)}}</div>
            <div class="table__item-wrapper">
              <div class="table__item-count">{{formatPrice(bucket.doc_count)}} шт</div>
              <div class="table__item-summ">{{formatPrice(bucket.sum.value)}} ₸</div>
            </div>
          </div>
        </template>
      </div>
    </template>
    <template v-else>
      <div class="not-found">
        <img class="" src="../assets/images/not-found.png" alt="">
        <div class="not-found__title">Выкупов не найдено </div>
        <div class="not-found__text">Попробуйте изменить настройки фильтра</div>
      </div>
    </template>

  </div>
</template>

<script>
  import {mapState} from 'vuex';
  export default {
    name: 'DayTable',
    data:() => ({
      isStoreCount: false,
      days: [],
    }),
    computed: {
      ...mapState(['elasticInfo']),
      setMaxNumber() {
        let maxNumberArray = [];
        this.days.map(info => {
          maxNumberArray.push(info.sum.value);
        });

        return Math.max(...maxNumberArray);
      },
      setMinNumber() {
        let maxNumberArray = [];
        this.days.map(info => {
          maxNumberArray.push(info.sum.value);
        });

        return Math.min(...maxNumberArray);
      },
    },
    watch: {
      elasticInfo(data) {
        if(data.aggregations.StoreCount.value !== undefined) {
          this.isStoreCount = true;
        }

        this.isStoreCount = !!data.aggregations.Days.buckets.length;
        this.days = data.aggregations.Days.buckets;
      }
    },
    methods: {
      formatPrice(value) {
        let val = (value / 1);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      },
      dateFormat(date) {
        const date2 = new Date(date);
        return date2.toLocaleString('ru', {year: 'numeric', month: 'long', day: 'numeric'});
      }
    },
    mounted() {
      // this.setMaxNumber();
    }
  };
</script>

<style scoped>

</style>
